
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {FormBuilder } from '@angular/forms';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { IPromotion, Promotion } from '../../../../../models/promotion.model';

import { Location } from '@angular/common';

import { PrivateSpaceService } from '../../../../../services/privateSpace.service';
import { IPrivateSpace, PrivateSpace } from '../../../../../models/privateSpace.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PostPrivateSpaceComponent } from '../post-private-space/post-private-space.component';
@Component({
  selector: 'app-private-space',
  templateUrl: './private-space.component.html',
  styleUrls: ['./private-space.component.scss']
})
export class PrivateSpaceComponent implements OnInit {

  @ViewChild('closebutton1') closebutton1;
  search: any;
  allPrivateSpaces: IPrivateSpace[] = [];
  allPrivateSpacesTmp: IPrivateSpace[] = [];
      // @ts-ignore
      public modalRef: BsModalRef;
  // @ts-ignore
  currentPrivateSpace: IPromotion = [];
  page = 1;
  sorted = false;
  sorted1 = false;
  sorted2 = false;
  sorted3 = false;
  sorted4 = false;
  isTrueName = false;

  perPage: number = 10;
  totalItems: any
  currentPage: number = 1;
  totalPages!: number;
  @ViewChild('closebutton') closebutton;

  constructor(private privateSpaceService: PrivateSpaceService, private fb: FormBuilder ,
              private router :Router,private location: Location,  private modalService: BsModalService,
             ) { }

  ngOnInit(): void {
    this.loadPrivateSpace();

  }

  model = {
    description: ''
  };



  goBack(): void {
    this.location.back();
  }

  disableButton = true;


 

  selectedStartDate : any;
  selectedEndDate : any;
  startDateNotAfterEndDate = false;
  endDateNotAfterStartDate = false;
  startDateNotEqualsEndDate = false;


  showPicker: boolean = true;
  selectedDateTime: string | null = null;

  closePicker() {
    // Handle any logic you need with the selectedDateTime
    this.showPicker = false;
  }

  closeDatetimePicker(inputElement: ElementRef) {
      inputElement.nativeElement.blur();
  }



  reloadComponent() {
    let currentUrl = this.router.url;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([currentUrl]);
  }








  validateStartDates(startDate: any): string | null {
    const currentDate = new Date();
    const startDateTime = new Date(startDate);
    const oneHourInMilliseconds = 60 * 60 * 1000;
    if (startDateTime.getTime() - currentDate.getTime() >= oneHourInMilliseconds) {
      return 'La date de début est supérieure d\'une heure ou plus à la date d\'aujourd\'hui';
    }
    return null;
  }

  validateEndDates(endDate: any): string | null {
    const currentDate = new Date();
    const endDateTime = new Date(endDate);

    if (endDateTime < currentDate) {
      return 'La date de fin est dépassée';
    }
    return null;
  }


  loadPrivateSpace(){
    this.allPrivateSpace(this.currentPage);
  }

  allPrivateSpace = (page: number)=>{
    this.privateSpaceService.getPrivateSpaceOld(page-1, this.perPage).subscribe(pr=>{
        this.allPrivateSpaces = pr.content;

        //this.allPrivateSpaces = this.sortByDate(this.allPrivateSpaces)
        this.allPrivateSpacesTmp = pr.content;
        //this.allPrivateSpacesTmp = this.sortByDate(this.allPrivateSpacesTmp)
        this.totalItems = pr.totalElements;
        //this.perPage = pr.size;
        //this.totalPages = pr.totalPages;
        // console.log("Annonce en promotions");
        // console.log(this.allPrivateSpaces);
      });
}

onPageChange(page: number): void {
  this.currentPage = page; // Met à jour la page courante
  this.loadPrivateSpace(); // Recharge les données pour la page courante
}


sortByDate(pr: IPrivateSpace[]): IPrivateSpace[] {
  pr.sort((a, b) => {
    const dateA = new Date(a.createdAt).getTime(); 
    const dateB = new Date(b.createdAt).getTime();
    return dateB - dateA; 
  });
  return pr;
}



  // displayPerPage(value: any) {
  //   this.perPage = parseInt(value, 10);
  //  // console.log(this.perPage);
  // }

  displayPerPage(newPerPage: string): void {
    this.perPage = parseInt(newPerPage, 10); 
    this.currentPage = 1; 
    this.loadPrivateSpace(); 
}


  pagination(){
  this.loadPrivateSpace();
    
  }

  close() {
    this.closebutton.nativeElement.click();
  }

  close1() {
    this.closebutton1.nativeElement.click();
  }

  sort2() {
    if(this.sorted == false) {
      // @ts-ignore
      this.allPrivateSpaces.sort((a, b) => a.seller.lastname > b.seller.lastname ? 1 : a.seller.lastname < b.seller.lastname ? -1 : 0)
      this.sorted = true;
    } else {
      // @ts-ignore
      this.allPrivateSpaces.sort((a, b) => a.seller.lastname < b.seller.lastname ? 1 : a.seller.lastname > b.seller.lastname ? -1 : 0)
      this.sorted = false;
    }
  }

  sort1() {
    if(this.sorted1 == false) {
      // @ts-ignore
      this.allPrivateSpaces.sort((a, b) => a?.name > b?.name ? 1 : a?.name < b?.name ? -1 : 0)
      this.sorted1 = true;
    } else {
      // @ts-ignore
      this.allPrivateSpaces.sort((a, b) => a?.name < b?.name ? 1 : a?.name > b?.name ? -1 : 0)
      this.sorted1 = false;
    }
  }

  sort3() {
    if(this.sorted2 == false) {
      // @ts-ignore
      this.allPrivateSpaces.sort((a, b) => a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0)
      this.sorted2 = true;
    } else {
      // @ts-ignore
      this.allPrivateSpaces.sort((a, b) => a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0)
      this.sorted2 = false;
    }
  }

  

 

  copied = false;
  copiedCode: string = ''; // Ajoutez cette ligne pour stocker le code promo copié

  copyToClipboard(content: string) {
    const textArea = document.createElement('textarea');
    textArea.value = content;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);

    this.copied = true;
    this.copiedCode = content; // Stocke le code promo copié

    setTimeout(() => {
      this.copied = false;
      this.copiedCode = ''; // Réinitialiser après un délai
    }, 2000);
  }

  deletePrivateSpace(pr:IPrivateSpace){
    Swal.fire({
      title: 'Voulez-vous vraiment supprimer cet espace ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.privateSpaceService.deletePrivateSpace(pr.id).subscribe(
          rs=> {
  
            // console.log("Response de la suppression")
            // console.log(rs)
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Votre espace est supprimé de la liste avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            this.loadPrivateSpace();
            this.reloadComponent();
          }, error => {
            // console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error?.error?.errorMessage,
              showConfirmButton: false,
              timer: 5500
            })
          }
        )
      }
    })
  
  }

  searchFilter($event: KeyboardEvent) {
    this.allPrivateSpaces =  this.allPrivateSpacesTmp.filter(
      value => value.name?.toLowerCase().includes(this.search) ||
      value.seller?.lastname.toString().includes(this.search) ||
      value.createdAt?.toString().includes(this.search)
     
    );
  }

  postPrivateSpace(pr: IPrivateSpace) {
    const modalRef: BsModalRef = this.modalService.show(PostPrivateSpaceComponent, {
        initialState: { pr },
        class: 'modal-dialog modal-xl',
        backdrop: false,
        ignoreBackdropClick: true
    });

    // Passer la référence du modal au composant parent
  modalRef.content.closeModal.subscribe(() => {
    modalRef.hide(); // Fermer le modal lorsque l'événement pour le fermer est émis
});
  }
}
